import {Model} from 'vue-mc'
import _ from 'lodash';

/**
 * Lab Service base model
 */
export default class BaseModel extends Model {

  options() {
    let options = super.options() || {};
    options.methods = this.methods();
    return options;
  }

  modelName() {
    return null;
  }

  formattedName() {
    let name = this.modelName();

    if (name !== null) {
      let split = name.split(/[-_]/);
      split = split.filter(function (el) {
        return el != null;
      });
      name = split.join(' ');
    }
    return name;
  }

  icon() {
    return null;
  }

  // Default attributes that define the "empty" state.
  defaults() {
    return {}
  }

  // Attribute mutations.
  mutations() {
    return {}
  }

  // Attribute validation
  validation() {
    return {}
  }

  methods() {
    return {
      fetch: "GET",
      fetchConnection: "GET",
      exists: "POST",
      save: "POST",
      update: "PUT",
      create: "POST",
      delete: "DELETE"
    }
  }

  getMethod(key) {
    let methods = this.methods();

    return methods[key];
  }

  // Route configuration
  routes() {
    let routes =  _.merge(this.privateRoutes(), this.publicRoutes());
    return routes;
  }

  publicRoutes() {
    return {};
  }

  privateRoutes() {
    return {};
  }

  createRequest(config) {
    //let token = window.$cookies.get('auth__access_token');
    let token = localStorage['auth__access_token'];
    if (token) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return new super.createRequest(config);
  }

  fetchConnection(connection, params) {
    let method = this.getOption('methods.fetchConnection');
    let route = this.getRoute('fetchConnection');
    let url = this.getURL(route, {
      id: this.get(this.getOption('identifier')),
      connection
    });
    return this.createRequest({method, url, params}).send().then((response) => {
      this.emit('fetchConnection', {error: null, connection: connection});
      return response;
    });
  }

  exists() {
    let method = this.getOption('methods.exists');
    let route = this.getRoute('exists');
    let url = this.getURL(route);
    return this.createRequest({method, url, params: this.attributes}).send().then((response) => {
      this.emit('exists', {error: null, result: response});
      return response;
    });
  }

  getRelatedCollection(collection, key) {
    if (!this.connection_cache) {
      this.connection_cache = {};
    }

    if (this.connection_cache && this.connection_cache[key]) {
      const collection = this.connection_cache[key];
      this.emit('relatedCollectionLoaded', { error: null, key, collection });
      return this.connection_cache[key];
    }

    const value = this.get(key);

    if (value && value.length && Array.isArray(value)) {
      value.forEach((insert) => {
        const model = (new (collection.model())(insert));
        collection.add(model);
      });
      this.emit('relatedCollectionLoaded', { error: null, key, collection });
    } else if(!value) {
      const params = collection.getFilter();
      params.connection = key;
      this.fetchConnection(key).then((response) => {
        this.set(key, response.data);
        const models = collection.getModelsFromResponse(response);
        collection.replace(models);
        this.emit('relatedCollectionLoaded', { error: null, key, collection });
      });
    }
    this.connection_cache[key] = collection;
    return this.connection_cache[key];
  }

  getExternalRelatedCollection(collection, key, foreign_key, foreign_id) {
    if (!this.connection_cache) {
      this.connection_cache = {};
    }
    if (this.connection_cache && this.connection_cache[key]) {
      let collection = this.connection_cache[key];
      this.emit('relatedCollectionLoaded', {error: null, key, collection});
      return this.connection_cache[key];
    }
    collection.getFilter().filterEquals(foreign_key, foreign_id);
    collection.fetch().then(() => {
      this.emit('relatedCollectionLoaded', {error: null, key, collection});
    });
    this.connection_cache[key] = collection;
    return this.connection_cache[key];
  }

  getRelatedModel(model, key) {
    if (!this.connection_cache) {
      this.connection_cache = {};
    }
    if (this.connection_cache && this.connection_cache[key]) {
      this.emit('relatedModelLoaded', {error: null, key, model: this.connection_cache[key]});
      return this.connection_cache[key];
    }
    let value = this.get(key);
    if (value) {
      this.connection_cache[key] = (new model(value));
      this.emit('relatedModelLoaded', {error: null, key, model: this.connection_cache[key]});
      return this.connection_cache[key];
    } else {
      if(value === null) {
        return this.connection_cache[key] = (new model());
      }
      this.fetchConnection(key).then((response) => {
        this.set(key, response);
        this.emit('relatedModelLoaded', {error: null, key, model: this.connection_cache[key]});
      });
      return this.connection_cache[key] = (new model(this[key]));
    }
  }

  getExternalRelatedModel(model, key, foreign_key) {
    if (!this.connection_cache) {
      this.connection_cache = {};
    }
    if (this.connection_cache && this.connection_cache[key]) {
      this.emit('relatedModelLoaded', {error: null, key, model: this.connection_cache[key]});
      return this.connection_cache[key];
    }
    let value = this.get(foreign_key);
    if (value) {
      this.connection_cache[key] = (new model({id: value}));
      this.connection_cache[key].fetch().then(() => {
        this.emit('relatedModelLoaded', {error: null, key, model: this.connection_cache[key]});
      });
      return this.connection_cache[key];
    } else {
      this.connection_cache[key] = (new model());
      this.emit('relatedModelLoaded', {error: null, key, model: this.connection_cache[key]});
      return this.connection_cache[key];
    }
  }

  /**
   *
   * @param val
   * @returns {string|null}
   */
  nullStringMutator(val) {
    return _.toString(val) || null;
  }


}
